import { render, staticRenderFns } from "./SongForm.vue?vue&type=template&id=e212c2d8"
import script from "./SongForm.vue?vue&type=script&lang=js"
export * from "./SongForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports